import { useEffect, useState } from "react";
import { List, X } from "@phosphor-icons/react";
import { Logo } from "../Logo";
import { GoldButton } from "../GoldButton";
import { NAV_LINKS, waLink } from "../../config/site";

export const Nav = () => {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const experimentalMsg =
    "Oi! Quero garantir minha aula experimental na Templo Savassi.";

  const solid = scrolled || open;
  const linkColor = solid ? "text-slate hover:text-gold" : "text-cream/85 hover:text-gold-light";

  return (
    <header
      data-testid="main-navigation"
      className={`fixed top-0 inset-x-0 z-50 transition-all duration-500 ${
        solid
          ? "bg-paper/85 backdrop-blur-xl border-b border-line"
          : "bg-transparent"
      }`}
    >
      <nav className="max-w-7xl mx-auto px-6 md:px-12 h-[76px] flex items-center justify-between">
        <a href="#top" data-testid="nav-logo-link" aria-label="Templo início">
          <Logo compact tone={solid ? "dark" : "light"} />
        </a>

        <div className="hidden lg:flex items-center gap-9">
          {NAV_LINKS.map((l) => (
            <a
              key={l.href}
              href={l.href}
              data-testid={`nav-link-${l.href.slice(1)}`}
              className={`font-body text-[15px] md:text-base transition-colors duration-300 tracking-wide ${linkColor}`}
            >
              {l.label}
            </a>
          ))}
        </div>

        <div className="hidden lg:block">
          <GoldButton
            href={waLink(experimentalMsg)}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="nav-cta-experimental"
          >
            Aula experimental
          </GoldButton>
        </div>

        <button
          className={`lg:hidden p-2 -mr-2 transition-colors ${solid ? "text-ink" : "text-cream"}`}
          onClick={() => setOpen((v) => !v)}
          data-testid="nav-hamburger"
          aria-label="Abrir menu"
        >
          {open ? <X size={26} weight="light" /> : <List size={26} weight="light" />}
        </button>
      </nav>

      {open && (
        <div
          className="lg:hidden bg-paper border-b border-line px-6 pb-8 pt-2"
          data-testid="mobile-menu"
        >
          <div className="flex flex-col gap-1">
            {NAV_LINKS.map((l) => (
              <a
                key={l.href}
                href={l.href}
                onClick={() => setOpen(false)}
                data-testid={`mobile-nav-link-${l.href.slice(1)}`}
                className="font-body text-ink py-3 border-b border-line tracking-wide"
              >
                {l.label}
              </a>
            ))}
            <GoldButton
              href={waLink(experimentalMsg)}
              target="_blank"
              rel="noopener noreferrer"
              onClick={() => setOpen(false)}
              className="mt-5 w-full"
              data-testid="mobile-cta-experimental"
            >
              Aula experimental
            </GoldButton>
          </div>
        </div>
      )}
    </header>
  );
};
